import { Box, InputAdornment, TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import CopyButton from 'components/@home/drawers/ProfileDrawer/Profile/EmployeeActions/InviteLink/CopyButton';
import React, { useRef } from 'react';

type CopyFieldProps = Omit<TextFieldProps, 'value'> & {
  value: string;
};

const CopyField = ({ value, slotProps, ...rest }: CopyFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const select = () => {
    setTimeout(() => inputRef.current?.select?.(), 10);
  };

  const htmlInputSlot =
    typeof slotProps?.htmlInput === 'function' ? undefined : slotProps?.htmlInput;
  const inputSlot = typeof slotProps?.input === 'function' ? undefined : slotProps?.input;

  return (
    <TextField
      value={value}
      inputRef={inputRef}
      slotProps={{
        ...slotProps,
        htmlInput: {
          readOnly: true,
          ...htmlInputSlot,
          onSelect: select,
          onMouseDown: select,
        },
        input: {
          sx: { bgcolor: 'secondary.ultraLight' },
          endAdornment: (
            <InputAdornment position="end">
              <Box sx={{ display: 'flex', height: 33.5, mr: -1.5 }}>
                <CopyButton
                  value={value}
                  inputRef={inputRef}
                  size="small"
                  ButtonProps={{
                    size: 'small',
                    sx: {
                      bgcolor: 'white',
                      minHeight: 'auto',
                      mr: 0.25,
                    },
                  }}
                />
              </Box>
            </InputAdornment>
          ),
          ...inputSlot,
        },
      }}
      fullWidth
      {...rest}
    />
  );
};

export default CopyField;
